import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/api';

interface Vars {
  groupId: string;
  userId: string;
}

/**
 * Owner-only: remove a non-owner member from the group. Uses the same
 * `DELETE /api/groups/:id/members/:userId` endpoint as `useLeaveGroup` — the
 * server enforces the permissions (owner-removes-anyone vs. self-leaves).
 *
 * On success invalidates the members list, `['groups','my']` (member count
 * cards update), and the standings (scope totals shift).
 */
export function useKickMember() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ groupId, userId }: Vars) =>
      api.delete<{ ok: true }>(`/api/groups/${groupId}/members/${userId}`),
    onSuccess: (_data, vars) => {
      void qc.invalidateQueries({
        queryKey: ['groups', 'members', vars.groupId],
      });
      void qc.invalidateQueries({ queryKey: ['groups', 'my'] });
      void qc.invalidateQueries({ queryKey: ['standings'] });
    },
  });
}
